export default "__VITE_ASSET__CKFVkw5L__"